import React, { Component } from 'react';
import axios from 'axios';
import { Row, Col, Card, CardImg, CardTitle } from 'reactstrap';
import Swiper from 'react-id-swiper';
import { connect } from "react-redux";
import { FormattedMessage } from 'react-intl';
import VideoModal from './VideoModal'
import { isGamiclub } from '../../constants/isGamiclub';

class Videos extends Component {
    constructor(props) {
        super(props);
        this.state={
            isModalOpen:false,
            selectedVideo:null,
            selectedVideoTitle:'',
            poster: ''
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    handleSelectedVideo=(data)=>{
        this.setState({
            selectedVideo:data.video_url,
            isModalOpen:true,
            selectedVideoTitle:data.title,
            poster:data.images_url
        })
    }
    
    onCloseModal=()=>{
        this.setState({
            isModalOpen:false
        })
    }
    

    render() {
        const {selectedVideo,isModalOpen, selectedVideoTitle, poster} =this.state;
        
        const gamesParams = {
            direction: 'horizontal',
            slidesPerView: 'auto',
            speed: 500,
        }
        
        var gameCategoryTitleClass = "game-category-title";
        
        return (
            <div>
                <VideoModal url={selectedVideo} title={selectedVideoTitle} onCloseModal={this.onCloseModal} isModalOpen={isModalOpen} poster={poster} />
                {this.props.video.map((item) => {
                    return(
                        <div>
                        <Row>
                            <Col xs="12" className="game-related-container">
                                <div className="game-related-top">
                                    <div className="game-category" style={isGamiclub ? {borderBottom: '1px solid green'} : null}>
                                        <h2 style = {isGamiclub ? {color: 'white', backgroundColor: 'green'} : null} className={gameCategoryTitleClass}><i className="fa fa-video-camera" aria-hidden="true"></i>
                                        <FormattedMessage id="VideosGamingTips"
                                                    defaultMessage={item.category_name}
                                        />
                                        </h2>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="game-list-row">
                            <Col xs="12">
                                <Swiper {...gamesParams} shouldSwiperUpdate={true}>
                                {item.data.map((each_item) => {
                                    return(
                                        <div className="swiper-wallpaper-card" key={each_item.id}>
                                        <Card className={!isGamiclub ? "wallpaper-card" : "wallpaper-card-gamiclub"} onClick={()=>this.handleSelectedVideo(each_item)}>
                                            <div className="wallpaper-card-inner">
                                                <div className="wallpaper-thumb-wrap">
                                                    <CardImg className="wallpaper-thumb" style={{objectFit: 'cover', height: '150px'}} alt={each_item.title} src={each_item.images_url} />
                                                </div>
                                                <span className="wallpaper-title"><strong>{each_item.title}</strong></span>
                                            </div>
                                        </Card>
                                        </div>
                                    )
                                })}
                                </Swiper>
                            </Col>
                        </Row>
                    </div>
                    )
                })}                
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer
    };
};


export default connect(mapStateToProps, null)(Videos);



// WEBPACK FOOTER //
// ./src/components/UploadVideos/video.js